import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css']
})
export class SkillsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
    this.animateAllCircles();
    this.animateAllLineProgresses();
  }

  animateCircles(element) {

    const circ25 = element.children[1];
    const circ50 = element.children[2];
    const circ75 = element.children[3];


    circ25.style.transform = 'rotateZ(-87deg)';
    circ50.style.transform = 'rotateZ(-177deg)';
    circ75.style.transform = 'rotateZ(-267deg)';

    circ25.style.display = 'none';
    circ50.style.display = 'none';
    circ75.style.display = 'none';

    const percent = element.children[5].children[2];

    let deg = 0;
    let maxDeg = element.getAttribute('currgrade');
    maxDeg = 360 * (maxDeg / 100);
    const self = this;

    const interval = setInterval(function () {
      if (deg <= 90 && deg <= maxDeg) {
        self.rotateElem(circ25, 90 - deg);
        percent.innerHTML = '' + (Math.round(deg / 3.6)) + '%';
      } else if (deg <= 180 && deg <= maxDeg) {
        self.rotateElem(circ50, 180 - deg);
        percent.innerHTML = '' + (Math.round(deg / 3.6)) + '%';
      } else if (deg <= 270 && deg <= maxDeg) {
        self.rotateElem(circ75, 270 - deg);
        percent.innerHTML = '' + (Math.round(deg / 3.6)) + '%';
      } else {
        clearInterval(interval);
      }

      if (deg > 0) {
        circ25.style.display = 'block';
      }
      if (deg > 90) {
        circ50.style.display = 'block';
      }
      if (deg > 180) {
        circ75.style.display = 'block';
      }

      deg++;
    }, 5);

  }

  rotateElem(element, degree) {
    element.style.transform = 'rotateZ(-' + degree + 'deg)';
  }

  animateAllCircles() {

    const elementsSection = document.getElementsByClassName('rounded-progress');
    for (let i = 0; i < elementsSection.length; i++) {

      const elementSection = elementsSection[i];

      this.animateCircles(elementSection);
    }
  }

  animateAllLineProgresses() {

    const elementsSection = document.getElementsByClassName('linear-progress');

    for (let i = 0; i < elementsSection.length; i++) {
      const elementSection = elementsSection[i];
      this.animateLinearProgresses(elementSection);
    }
  }

  animateLinearProgresses(element) {

    const percent = element.children[0].children[1];
    const line = element.children[1];
    line.style.left = '-100%';

    let deg = 0;
    const maxDeg = element.getAttribute('currgrade');

    const interval = setInterval(function () {
      if (deg <= maxDeg) {
        line.style.left = '' + (deg - 100) + '%';
        percent.innerHTML = '' + deg + '%';
      } else {
        clearInterval(interval);
      }
      deg++;
    }, 10);

  }
}



// WEBPACK FOOTER //
// E:/Java/ResumeAngular/resume/src/app/skills/skills.component.ts